/**
 * Prints a report that is rendered into document.body (class "pz-report"): the application is hidden for the
 * print, the report shown (see styles.css). In the browser's print dialog "Save as PDF" creates the PDF file.
 */
export function printReport() {
  document.body.classList.add('pz-printing-report');
  const done = () => {
    document.body.classList.remove('pz-printing-report');
    window.removeEventListener('afterprint', done);
  };
  window.addEventListener('afterprint', done);
  try {
    window.print();
  } finally {
    // print() blocks in most browsers; where it does not, afterprint removes the class
    setTimeout(done, 1000);
  }
}
